// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RCP8","toggle":"styles_toggle__2TsZl","preview":"styles_preview__3L6-A"};